import { DropdownOption } from 'types/dropdown';

export enum ReportDateRangeOptionEnum {
  THIS_MONTH = 'this-month',
  LAST_MONTH = 'last-month',
  CURRENT_FINANCIAL_YEAR = 'current-financial-year',
  LAST_FINANCIAL_YEAR = 'last-financial-year',
  CUSTOM = 'custom'
}

export enum ReportTypes {
  GST = 'gst',
  SETTLEMENT = 'settlement',
  CUSTOM = 'custom'
}

export const ReportOptions: DropdownOption[] = [
  {
    id: ReportTypes.GST,
    label: 'GST Report',
    value: ReportTypes.GST
  },
  {
    id: ReportTypes.CUSTOM,
    label: 'Custom Report',
    value: ReportTypes.CUSTOM
  }
];

export const CategoryListOption: DropdownOption[] = [
  {
    id: 'paymentLinkGenerated',
    label: 'Payment Link Generated Date',
    value: 'payment-link'
  },
  {
    id: 'paid',
    label: 'Paid Date',
    value: 'paid'
  },
  {
    id: 'settlement',
    label: 'Settled Date',
    value: 'settlement'
  }
];
